var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layer pa-4 builder-loading",attrs:{"role":"status","aria-live":"polite"}},[_c('v-row',{staticClass:"flex-column fill-height",attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('Spinner'),_c('span',[_vm._v("Preparing your bike…")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }